// extracted by mini-css-extract-plugin
export default {"content_bg_gray":"index_content_bg_gray_ep1z6","content_bg_white":"index_content_bg_white_aDZ65","main":"index_main_2H5-a","space":"index_space_NdsO5"};